import { render, staticRenderFns } from "./welfareDaily.vue?vue&type=template&id=2e1d6d2c&scoped=true&"
import script from "./welfareDaily.vue?vue&type=script&lang=js&"
export * from "./welfareDaily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d6d2c",
  null
  
)

export default component.exports